import { basePath } from 'src/components/AppRoutes/Enterprise/EnterpriseBasePath';

const base = `${basePath}/parents`;

export const ParentPaths = {
  base,
  create: `${base}/create`,
  edit: `${base}/:corpid`,
  editChild: `${base}/:corpid/children/:childId`,
};
